export default __webpack_public_path__ + "static/media/XCryptoLogo.d6fec78f.webp";